import { Injectable } from '@angular/core';
import { StatsigService } from '@services/statsig.service';

export enum MOTIVE_GPT_FLAGS {
  GEN_AI_POC_ENABLED = 'gen_ai_poc_enabled',
}

@Injectable({ providedIn: 'root' })
export class MotiveGptFeatureFlagService {
  constructor(private statsigService: StatsigService) {}

  public isGenAiPocEnabled(): boolean {
    return this.statsigService
      .evaluateGate(MOTIVE_GPT_FLAGS.GEN_AI_POC_ENABLED)
    ;
  }
}
